import LiveGeneralEnrollmentService from './live/general/LiveGeneralEnrollmentService';
import LiveProjectEnrollmentService from './live/project/LiveProjectEnrollmentService';
import LiveNetworkEnrollmentService from './live/network/LiveNetworkEnrollmentService';

export default {
  general: LiveGeneralEnrollmentService,
  network: LiveNetworkEnrollmentService,
  project: LiveProjectEnrollmentService
};
